module.exports = __webpack_public_path__ + "img/Cross.09b882e0.svg";